import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Geocode from "react-geocode";
import classNames from "classnames";
import { Styles } from "../assests/js/PopupTheme";
import Autocomplete1 from "../Utils/GenericUI/Select";
import Map from "./Map";
import {
  getPCPsWithCoords,
  setPcpData,
  searchAndSetPcp,
  setStateParams,
} from "../Redux/Actions/webAppActions";
import { Loader } from "@googlemaps/js-api-loader";
//import { REACT_APP_GOOGLE_MAPS_API_KEY } from "../Utils/StaticData/Constant";
const SELECT_OBJ = {
  label: "Select",
  value: "",
};

const AssignPCPPopup = (props) => {
  const LANG_OPTIONS = [
    SELECT_OBJ,
    {
      label: "English",
      value: "ENG",
    },
    {
      label: "Spanish",
      value: "SPA",
    },
  ]; //props.languages ? [...props.languages] : [SELECT_OBJ];
  //Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
  const GENDER_OPTIONS = [
    SELECT_OBJ,
    {
      label: "Male",
      value: "M",
    },
    {
      label: "Female",
      value: "F",
    },
  ];
  const [language, setLanguage] = useState(LANG_OPTIONS[0].value);
  const [gender, setGender] = useState(GENDER_OPTIONS[0].value);
  const [selectedPCP, setSelectedPCP] = useState(null);
  const [pcps, setPcps] = useState([]);
  const [mapKey, setKey] = useState(1);
  const [resetFlag, setResetFlag] = useState(false);
  const [primAddress, setPrimAddress] = useState({});
  const [preSelectedPCP, setPreSelectedPCP] = useState({});
  const [loadPcp, setLoadPcp] = useState({});
  const {pcpApiKey} = useSelector((state)=>state.login)

  const loader = new Loader({
    apiKey: pcpApiKey,
    version: "weekly",
    libraries: ["places"],
  });
  useEffect(() => {
    let primAddr = `${
      props.data.permanentAddress.streetAddress
        ? props.data.permanentAddress.streetAddress
        : props.data.permanentAddrStreet
    },${
      props.data.permanentAddress.city
        ? props.data.permanentAddress.city
        : props.data.permanentCity
    },${
      props.data.permanentAddress.state
        ? props.data.permanentAddress.state
        : props.data.permanentState
    },${
      props.data.permanentAddress.zipCode
        ? props.data.permanentAddress.zipCode
        : props.data.permanentZip
    },United States`;
    loader.load().then((google) => {
      let geocoder1 = new google.maps.Geocoder();
      geocoder1.geocode({ address: primAddr }, (results, status) => {
        let res = JSON.stringify(results[0].geometry.location);
        const { lat, lng } = JSON.parse(res);
        const address = {
          lat: lat,
          lng: lng,
        };
        setPrimAddress(address);
        setKey(3);
      });
      setKey(2);
    });
    setKey(4);
  }, [props.data]);

  useEffect(() => {
    if (
      props.preEnrollInfo &&
      props.preEnrollInfo.pcpName &&
      props.flag === false
    ) {
      props.setFlag();
      const address = {
        latlng: {
          lat: parseFloat(props.preEnrollInfo.pcpDetails.lat),
          lng: parseFloat(props.preEnrollInfo.pcpDetails.lng),
        },
        selected: true,
      };
      setLoadPcp(address);
      setPreSelectedPCP(address);
      setSelectedPCP({
        ...selectedPCP,
        doctorName: props.preEnrollInfo.pcpName,
        doctorAddress: props.preEnrollInfo.pcpDetails.address,
        latitude: props.preEnrollInfo.pcpDetails.lat,
        longitude: props.preEnrollInfo.pcpDetails.lng,
        acceptAutoAssign: "",
        gender: props.preEnrollInfo.pcpDetails.gender,
        googleApiDistance: props.preEnrollInfo.pcpDetails.googleApiDistance,
        clinicName: props.preEnrollInfo.pcpDetails.name,
        providerCode: props.preEnrollInfo?.officeCd,
        state: props.preEnrollInfo?.pcpDetails.state,
        zipcode: props.preEnrollInfo?.pcpDetails.zipcode,
      });
    }
  }, [props.preEnrollInfo]);

  useEffect(() => {
    if (props.preSelectedPCP.pcpAddress) {
      let oldPCPAddr = `${props.preSelectedPCP.pcpAddress},${props.preSelectedPCP.pcpCity},${props.preSelectedPCP.pcpZip},United States`;
      Geocode.fromAddress(oldPCPAddr).then((response) => {
        const { lat, lng } = response.results[0].geometry.location;
        const address = {
          latlng: {
            lat: lat,
            lng: lng,
          },
          selected: true,
        };
        setPreSelectedPCP(address);
      });
    }
  }, [props.preSelectedPCP]);

  useEffect(() => {
    if (props.selectedIndex || props.selectedIndex == 0) {
      let pcp = props.pcpList;
      let newPCPs1 = pcp.map((newPcp) => {
        return { ...newPcp, selected: false, choosen: false };
      });
      newPCPs1[props.selectedIndex] = {
        ...pcp[props.selectedIndex],
        selected: true,
        choosen: true,
      };
      setPcps(newPCPs1);
    } else {
      setPcps(props.pcpList);
    }
  }, [props.pcpList]);

  const handlePCP = (pcp) => {
    setSelectedPCP(pcp);
  };
  const handlePCPList = (list) => {
    setPcps(list);
  };
  const handleLanguageChange = (val) => {
    handlePCPFilter(gender, val);
    setLanguage(val);
    setKey(mapKey + 1);
  };
  const handleGenderChange = (val) => {
    handlePCPFilter(val, language);
    setGender(val);
    setKey(mapKey + 1);
  };
  const handlePCPFilter = (gen, lan) => {
    let genderFilteredPCPs = [];
    let langFilteredPCPs = [];
    if (gen !== "") {
      genderFilteredPCPs = props.pcpList.filter((pcp) => {
        return pcp.gender.toLowerCase() === gen.toLowerCase();
      });
    } else {
      genderFilteredPCPs = props.pcpList;
    }
    if (lan !== "") {
      langFilteredPCPs = genderFilteredPCPs.filter((pcp) => {
        return pcp.language === lan;
      });
    } else {
      langFilteredPCPs = genderFilteredPCPs;
    }

    setPcps(langFilteredPCPs);
  };
  const onSubmit = () => {
    if (!selectedPCP) {
      props.close();
      return;
    }
    const payload = {
      pcpOfficeCd: selectedPCP.providerCode,
      PcpLocationId: selectedPCP.locationId,
      pcpName: selectedPCP.doctorName ? selectedPCP.doctorName : "no",
      pcpCurrPatnt: selectedPCP.currentPatientInd,
      pcpOffCatCd: selectedPCP.providerCategoryCode,
      pcpNpiId: selectedPCP.alternateOfficeCode,
      pcpAddress: selectedPCP.doctorAddress,
      pcpCity: selectedPCP.city,
      pcpState: selectedPCP.stateCode,
      pcpZip: selectedPCP.zipCode,
      distance: selectedPCP.googleApiDistance,
    };
    props.setPcpData(payload);
    props.close();
  };
  const setFlg = () => {
    setResetFlag(false);
  };
  const reset = () => {
    setResetFlag(true);
    setGender(GENDER_OPTIONS[0].value);
    setLanguage(LANG_OPTIONS[0].value);
    setSelectedPCP(null);
    props.setPcpData([]);
    if (Object.keys(props?.preEnrollInfo)?.length !== 0) {
      let preinfo = props.preEnrollInfo;
      preinfo.pcpName = "";
      preinfo.clinicName = "";
      preinfo.pcpDetails = {};
      props.setStateParams("preEnrollInfo", preinfo);
    }
    handlePCPFilter(GENDER_OPTIONS[0].value, LANG_OPTIONS[0].value);
    setKey(mapKey + 1);
    props.setStateParams("selectedIndex", null);
    props.isReset();
  };

  const primaryAddress = (
    <div class="line-height-0-5 font-size-12px">
      <p>
        {props.data.permanentAddress.streetAddress
          ? props.data.permanentAddress.streetAddress
          : props.data.permanentAddrStreet}
      </p>
      <p>
        {props.data.permanentAddress.city
          ? props.data.permanentAddress.city
          : props.data.permanentCity}
        {", "}
        {props.data.permanentAddress.state
          ? props.data.permanentAddress.state
          : props.stateId
          ? props.stateId
          : props.data.permanentState}
        {" - "}
        {props.data.permanentAddress.zipCode
          ? props.data.permanentAddress.zipCode
          : props.data.permanentZip}
      </p>
      <p>
        {props.data.permanentAddress.county
          ? props.data.permanentAddress.county
          : props.data?.permanentCounty?.countyName
          ? props.data?.permanentCounty?.countyName
          : props.data?.permanentCounty}
      </p>
    </div>
  );
  const selectedPCPShow = (
    <div style={{ margin: "0px 10px 10px 21px" }}>
      {" "}
      <p>
        <span className={props.classes.boldText}>Name :</span>{" "}
        {selectedPCP?.doctorName
          ? selectedPCP.doctorName
          : props.preSelectedPCP
          ? props.preSelectedPCP.pcpName
          : ""}
      </p>
      <p>
        <span className={props.classes.boldText}>Provider code :</span>{" "}
        {selectedPCP?.providerCode
          ? selectedPCP.providerCode
          : props.preSelectedPCP
          ? props?.preSelectedPCP?.providerCode
          : ""}
      </p>
      <p>
        <span className={props.classes.boldText}>Address :</span>{" "}
        {selectedPCP?.doctorAddress
          ? selectedPCP.doctorAddress +
            "," +
            `${selectedPCP.state ? selectedPCP.state : ""}-${
              selectedPCP.zipcode ? selectedPCP.zipcode : ""
            }`
          : props.preSelectedPCP
          ? props.preSelectedPCP.pcpAddress +
            `,${props.preSelectedPCP.pcpCity},${props.preSelectedPCP.pcpState}-${props.preSelectedPCP.pcpZip}`
          : ""}
      </p>
      <p>
        <span className={props.classes.boldText}>Distance :</span>{" "}
        {selectedPCP?.googleApiDistance
          ? selectedPCP.googleApiDistance
          : props.preSelectedPCP
          ? props.preSelectedPCP.distance
          : ""}{" "}
        {selectedPCP?.googleApiDistance ? "mi" : "-"}
      </p>
    </div>
  );
  return (
    <div className={props.classes.assignPCPPopup}>
      <div
        className={`${props.classes.legend} ${props.classes.assignPCPBanner}`}
      >
        <legend className={`${props.classes.legendAlign} pcp-font`}>
          PCP Assign
        </legend>
        <div class="w-70">
          {" "}
          <i
            className={`${classNames("fa fa-times")} ${
              props.classes.closeIconAlign
            }`}
            onClick={props.close}
          />
        </div>
      </div>
      <div className={props.classes.assignPCPFieldBox}>
        <div class="assign-pcp-primAddr">
          <span className={props.classes.headingMargin}>
            <h6 className={props.classes.heading}>Primary Address</h6>
          </span>
          <div>
            <div class="assign-pcp-orimAddr-margin"> {primaryAddress}</div>
          </div>
        </div>

        <div className={props.classes.fieldColumnBox1}>
          <span className={props.classes.headingMargin}>
            <h6 className={props.classes.heading}>Selected PCP</h6>
          </span>
          <div className="line-height-0-5">
            {(selectedPCP || props.preSelectedPCP.pcpName) &&
            resetFlag === false ? (
              <div>{selectedPCPShow}</div>
            ) : (
              <div class="selected-pcp-margin">
                Selected PCP details will show here.
              </div>
            )}
          </div>
        </div>
      </div>
      <div class="margin-top-n25px">
        <span class="filter-margin">
          <h6 className={props.classes.heading}>Filter By</h6>
        </span>
        <div className={props.classes.assignPCPFields}>
          <div className="assignPCP-filelds-mobile-aligner display-flex">
            <div>
              <span class="label-container">
                <label class="labelprospect assign-pcp-gender">Gender</label>
                <br />
                <div className={props.classes.pcpField}>
                  <Autocomplete1
                    handleChange={(e) => handleGenderChange(e.value)}
                    marginLeft="15px"
                    textFieldProps={{
                      InputLabelProps: {
                        className: props.classes.labelAutoComplete,
                        shrink: true,
                      },
                    }}
                    options={GENDER_OPTIONS}
                    width="200px"
                    defaultValue={GENDER_OPTIONS[0]}
                    value={
                      GENDER_OPTIONS.filter((data) => data.value === gender)[0]
                    }
                    name="gender"
                  />
                </div>
              </span>
            </div>
            <div>
              <span class="label-container">
                <label
                  for="prospect_gender"
                  class="labelprospect assign-pcp-language"
                >
                  Language
                </label>
                <br />
                <div className={props.classes.pcpField}>
                  <Autocomplete1
                    handleChange={(event) => {
                      handleLanguageChange(event.value);
                    }}
                    marginLeft="15px"
                    textFieldProps={{
                      InputLabelProps: {
                        className: props.classes.labelAutoComplete,
                        shrink: true,
                      },
                    }}
                    options={LANG_OPTIONS}
                    width="200px"
                    defaultValue={LANG_OPTIONS[0]}
                    value={
                      LANG_OPTIONS.filter((data) => data.value === language)[0]
                    }
                    name="lang"
                  />
                </div>
              </span>
            </div>
          </div>
          <div class="display-flex mtop-18px">
            <div class="m-right-10px">
              <Button
                variant="outlined"
                className={props.classes.modifiedButton1}
                onClick={reset}
              >
                Reset
              </Button>
            </div>
            <Button
              variant="outlined"
              className={props.classes.modifiedButton}
              onClick={onSubmit}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
      <div class="assign-pcp-map-comp" key={mapKey}>
        {loader.done === true && (
          <Map
            gender={gender}
            language={language}
            handlePCP={handlePCP}
            pcps={pcps}
            pcpList={props.pcpList}
            handlePCPList={handlePCPList}
            primaryAddress={primAddress}
            preSelectedPCP={preSelectedPCP}
            loadPcp={loadPcp}
            setResetFlag={setFlg}
            mapKey={mapKey}
          />
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    preEnrollInfo: state.webApp.preEnrollInfo,
    selectedIndex: state.webApp.selectedIndex,
  };
};
const mapDispatchToProps = {
  getPCPsWithCoords,
  setPcpData,
  searchAndSetPcp,
  setStateParams,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(Styles)(AssignPCPPopup));
